import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
// import classNames from "classnames";
// @material-ui/core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/icons
import D1Icon from "@material-ui/icons/Palette";
import D2Icon from "@material-ui/icons/People";
import D3Icon from "@material-ui/icons/AssignmentTurnedIn";
import D4Icon from "@material-ui/icons/ImportantDevices";
import D5Icon from "@material-ui/icons/Favorite";
import D6Icon from "@material-ui/icons/Work";
import D7Icon from "@material-ui/icons/Games";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import pdRecommendationStyle from "assets/jss/material-kit-pro-react/components/pdRecommendationStyle.jsx";

function PDRecommendation({ ...props }) {
  const { classes, id, domain, pdname, pdlink, score } = props;
  let iconDomain = null;
  let colorDomain = null;
  const backgroundColor = "yellow";
  let backgroundFlag = false;

  switch (domain) {
    case "D1":
      colorDomain = pdRecommendationStyle.d1.color;
      iconDomain = <D1Icon style={{ color: colorDomain }} />;
      // iconDomain = <D1Icon style={{ fontSize: "2em", color: colorDomain }} />;
      break;
    case "D2":
      colorDomain = pdRecommendationStyle.d2.color;
      iconDomain = <D2Icon style={{ color: colorDomain }} />;
      break;
    case "D3":
      colorDomain = pdRecommendationStyle.d3.color;
      iconDomain = <D3Icon style={{ color: colorDomain }} />;
      break;
    case "D4":
      colorDomain = pdRecommendationStyle.d4.color;
      iconDomain = <D4Icon style={{ color: colorDomain }} />;
      break;
    case "D5":
      colorDomain = pdRecommendationStyle.d5.color;
      iconDomain = <D5Icon style={{ color: colorDomain }} />;
      break;
    case "D6":
      colorDomain = pdRecommendationStyle.d6.color;
      iconDomain = <D6Icon style={{ color: colorDomain }} />;
      break;
    case "D7":
      colorDomain = pdRecommendationStyle.d7.color;
      iconDomain = <D7Icon style={{ color: colorDomain }} />;
      break;
  }
  return (
    <div className={classes.domainCircleScoreStyle}>
      <GridContainer
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <GridItem xs={12} sm={12} md={8}>
          {iconDomain} {pdname}
        </GridItem>
        <GridItem xs={12} sm={12} md={2}>
          <a rel="noopener noreferrer" href={pdlink} target="_blank">
            <Button size="sm" color="primary">FIND OUT MORE</Button>
          </a>
        </GridItem>
      </GridContainer>
    </div>
  );
}

PDRecommendation.defaultProps = {
  iconColor: "gray"
};

PDRecommendation.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  pdname: PropTypes.string.isRequired,
  pdlink: PropTypes.string.isRequired
};

export default withStyles(pdRecommendationStyle)(PDRecommendation);
